<template>
  <div>
    <!-- <base-header class="pb-6 pb-8 pt-5 pt-md-8 bg-gradient-deli">

    </base-header> -->

    <div style="height: 100px;"></div>
    <b-container fluid class="mt--7">
      <b-row>
        <b-col>
          <light-table />
        </b-col>
      </b-row>
      <div class="mt-5"></div>
      <dark-table></dark-table>
    </b-container>
  </div>
</template>
<script>
import { Dropdown, DropdownItem, DropdownMenu, Table, TableColumn } from 'element-ui';
// import LightTable from "./Tables/RegularTables/LightTable.vue";
import LightTable from "./user/RegularUsers/tukar_owner.vue";
// import DarkTable from "./user/table_user.vue";

export default {
  components: {
    LightTable,
    // DarkTable,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn
  },
  data() {
    return {
      projects,
      users,
    };
  },
  mounted() {
    // Access the parameter from the route
    this.userId = this.$route.params.id;
    // console.log('User ID:', this.userId);
  },
};
</script>
<style>
.el-table.table-dark {
  background-color: #172b4d;
  color: #f8f9fe;
}

.el-table.table-dark th,
.el-table.table-dark tr {
  background-color: #172b4d;
}

.el-table.table-dark td,
.el-table.table-dark th.is-leaf {
  border-bottom: none;
}
</style>
